export default {
    DEVELOPMENT: 'development',
    STAGING: 'staging',
    PRODUCTION: 'production'
}